import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../../../contexts/CartContext";
import Footer from "../../Footer";
import "./CheckoutSuccess.css";

export default function CheckoutSuccess() {
    const { clearCart } = useCart();

    useEffect(() => {
        clearCart();
    }, [clearCart]);

    return (
        <>
            <div className="cs-page">
                <div className="cs-container">
                    <div className="cs-icon">&#10003;</div>
                    <h1 className="cs-title">THANK YOU FOR YOUR ORDER!</h1>
                    <p className="cs-message">
                        Your payment was successful. We'll start preparing your
                        craft roast coffee right away.
                    </p>
                    <p className="cs-detail">
                        You will receive a confirmation email shortly with your
                        order details.
                    </p>
                    <Link to="/" className="cs-home-btn">
                        BACK TO HOME
                    </Link>
                    <Link to="/our-coffee" className="cs-continue">
                        Continue Shopping
                    </Link>
                </div>
            </div>
            <Footer />
        </>
    );
}
